
const portfolioItems = [
  {
    title: 'Luxury Brand Identity',
    category: 'Branding',
    image: 'https://public.readdy.ai/ai/img_res/1081b848fac53a8e0ae8db1e46526dc3.jpg',
  },
  {
    title: 'Modern Logo Collection',
    category: 'Logo Design',
    image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20logo%20design%20collection%20on%20simple%20clean%20background%20creative%20geometric%20shapes%20and%20elegant%20typography%20professional%20brand%20marks%20with%20gold%20and%20navy%20color%20scheme%20contemporary%20design%20showcase&width=800&height=600&seq=portfolio-002&orientation=landscape',
  },
  {
    title: 'Social Media Campaign',
    category: 'Social Media',
    image: 'https://readdy.ai/api/search-image?query=social%20media%20post%20design%20templates%20on%20simple%20background%20instagram%20feed%20layout%20with%20modern%20graphics%20and%20elegant%20color%20palette%20professional%20digital%20marketing%20visuals%20with%20clean%20aesthetic%20and%20premium%20look&width=800&height=600&seq=portfolio-003&orientation=landscape',
  },
  {
    title: 'Corporate Branding',
    category: 'Branding',
    image: 'https://readdy.ai/api/search-image?query=corporate%20brand%20identity%20system%20on%20white%20background%20business%20stationery%20mockup%20with%20letterhead%20and%20envelope%20professional%20design%20with%20navy%20and%20gold%20colors%20elegant%20corporate%20materials%20showcase&width=800&height=600&seq=portfolio-004&orientation=landscape',
  },
  {
    title: 'Event Poster Design',
    category: 'Print Design',
    image: 'https://readdy.ai/api/search-image?query=luxury%20event%20poster%20design%20on%20simple%20background%20elegant%20typography%20and%20gold%20accents%20modern%20layout%20with%20sophisticated%20color%20scheme%20premium%20promotional%20material%20with%20clean%20aesthetic%20and%20professional%20look&width=800&height=600&seq=portfolio-005&orientation=landscape',
  },
  {
    title: 'YouTube Thumbnail Set',
    category: 'Digital Design',
    image: 'https://readdy.ai/api/search-image?query=youtube%20thumbnail%20design%20collection%20on%20simple%20background%20eye%20catching%20graphics%20with%20bold%20typography%20professional%20video%20cover%20designs%20with%20modern%20aesthetic%20and%20vibrant%20colors%20digital%20content%20showcase&width=800&height=600&seq=portfolio-006&orientation=landscape',
  },
];

export default function Portfolio() {
  return (
    <section id="portfolio" className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 font-['Montserrat']">
            Featured <span className="text-[#fcd34d]">Portfolio</span>
          </h2>
          <p className="text-white/60 text-lg font-['Roboto'] max-w-2xl mx-auto">
            Explore a curated selection of my finest work showcasing creativity and excellence
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolioItems.map((item, index) => (
            <div
              key={index}
              className="group relative bg-white/5 backdrop-blur-xl rounded-2xl overflow-hidden border border-white/10 hover:border-[#fcd34d]/50 shadow-xl hover:shadow-2xl hover:shadow-[#fcd34d]/20 transition-all duration-500 hover:scale-105 cursor-pointer"
            >
              <div className="relative w-full h-80 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0f172a] via-[#0f172a]/50 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500"></div>
                
                <div className="absolute inset-0 bg-gradient-to-br from-[#fcd34d]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-shimmer"></div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                <span className="inline-block px-3 py-1 bg-[#fcd34d]/20 backdrop-blur-md text-[#fcd34d] text-sm rounded-full mb-3 font-['Roboto'] border border-[#fcd34d]/30">
                  {item.category}
                </span>
                <h3 className="text-xl font-bold text-white font-['Montserrat'] group-hover:text-[#fcd34d] transition-colors duration-300">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
